<template>
  <div>
    <HeadAndMeta />
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <AppSnackbar />
  </div>
</template>

<script setup lang="ts">
import { useRootStore } from "./stores/root-store";

onMounted(() => {
  const nuxtApp = useNuxtApp();
  const rootStore = useRootStore(nuxtApp.$pinia);
  rootStore.setAppStart(true);

  // Suppress ResizeObserver loop errors
  // This is a known browser quirk that occurs when ResizeObserver callbacks
  // trigger layout changes that cause more resize events.
  // The error is harmless and doesn't affect functionality.
  // const isResizeObserverError = (message: string): boolean => {
  //   if (!message) return false;
  //   const errorMessage = message.toString().toLowerCase();
  //   return (
  //     errorMessage.includes("resizeobserver loop") ||
  //     errorMessage.includes("resizeobserver loop completed with undelivered notifications")
  //   );
  // };

  // // Store original console.error
  // const originalConsoleError = console.error;

  // // Override console.error to filter out ResizeObserver errors
  // console.error = (...args: any[]) => {
  //   const errorMessage = args[0]?.toString() || "";
  //   if (isResizeObserverError(errorMessage)) {
  //     return; // Suppress the error
  //   }
  //   originalConsoleError.apply(console, args);
  // };

  // // Suppress unhandled error events for ResizeObserver
  // const originalErrorHandler = window.onerror;
  // window.onerror = (message, source, lineno, colno, error) => {
  //   const errorMessage = message?.toString() || "";
  //   if (isResizeObserverError(errorMessage)) {
  //     return true; // Prevent default error handling
  //   }
  //   if (originalErrorHandler) {
  //     return originalErrorHandler(message, source, lineno, colno, error);
  //   }
  //   return false;
  // };

  // // Suppress unhandled promise rejections for ResizeObserver
  // window.addEventListener("unhandledrejection", (event) => {
  //   const errorMessage = event.reason?.toString() || "";
  //   if (isResizeObserverError(errorMessage)) {
  //     event.preventDefault();
  //     return;
  //   }
  // });

  // // Configure Bugsnag to ignore ResizeObserver errors if available
  // const bugsnagInstance = nuxtApp.$bugsnag as any;
  // if (bugsnagInstance && typeof bugsnagInstance.addOnError === "function") {
  //   bugsnagInstance.addOnError((event: any) => {
  //     const errorMessage = event.errors?.[0]?.errorMessage || "";
  //     if (isResizeObserverError(errorMessage)) {
  //       return false; // Don't send to Bugsnag
  //     }
  //     return true; // Allow other errors
  //   });
  // } else {
  //   // Fallback: Try to access Bugsnag from window if available
  //   if (typeof window !== "undefined") {
  //     const checkBugsnag = () => {
  //       const bugsnag = (window as any).Bugsnag || (window as any).$bugsnag;
  //       if (bugsnag && typeof bugsnag.addOnError === "function") {
  //         bugsnag.addOnError((event: any) => {
  //           const errorMessage = event.errors?.[0]?.errorMessage || "";
  //           if (isResizeObserverError(errorMessage)) {
  //             return false; // Don't send to Bugsnag
  //           }
  //           return true; // Allow other errors
  //         });
  //       } else {
  //         // Retry after a short delay if Bugsnag isn't ready yet
  //         setTimeout(checkBugsnag, 100);
  //       }
  //     };
  //     checkBugsnag();
  //   }
  // }
});
</script>
